const components = {
  /**
   * @override
   */
  Spinner() {
    return import(/* webpackChunkName: "Spinner" */ '@/components/ui/Spinner.vue');
  },
  /**
   * @override
   */
  FullScreen() {
    return import(/* webpackChunkName: "FullScreen" */ '@/components/full-screen/index.vue');
  },
  /**
   * @override
   */
  YuriLabel() {
    return import(/* webpackChunkName: "YuriLabel" */ '@/components/ui/yuri-label');
  },
  /**
   * @override
   */
  YuriInput() {
    return import(/* webpackChunkName: "YuriInput" */ '@/components/ui/yuri-input');
  },
  /**
   * @override
   */
  YuriButton() {
    return import(/* webpackChunkName: "YuriButton" */ '@/components/ui/yuri-button');
  },
  /**
   * @override
   */
  YuriModal() {
    return import(/* webpackChunkName: "YuriModal" */ '@/components/yuri-modal');
  },
  /**
   * @override
   */
  YuriIcon() {
    return import(/* webpackChunkName: "YuriIcon" */ '@/components/ui/yuri-icon');
  },
  /**
   * @override
   */
  YuriText() {
    return import(/* webpackChunkName: "YuriText" */ '@/components/ui/yuri-text');
  },
  /**
   * @override
   */
  Multiselect() {
    return import(/* webpackChunkName: "Multiselect" */ 'vue-multiselect');
  },
  /**
   * @override
   */
  DatePicker() {
    return import(/* webpackChunkName: "DatePicker" */ 'vue2-datepicker');
  },
  /**
   * @override
   */
  YuriDatePicker() {
    return import(/* webpackChunkName: "YuriDatePicker" */ '@/components/yuri-datepicker/index.vue');
  },
  /**
   * @override
   */
  VueGoogleAutocomplete() {
    return import(/* webpackChunkName: "VueGoogleAutocomplete" */ 'vue-google-autocomplete');
  },
  /**
   * @override
   */
  YuriLogin() {
    return import(/* webpackChunkName: "Spinner" */ '@/components/yuri-login/index.vue');
  }
};

export default components;
